const GraceListHeader = ({ listTitle, linkText, onClick }) => {
  return (
    <section className="mb-2 px-6">
      <h6 className="h6 mb-1">{listTitle}</h6>
      {linkText && (
        <a className="linkTextPrimary no-underline hover:cursor-pointer" onClick={onClick}>
          {linkText}
        </a>
      )}
    </section>
  );
};

GraceListHeader.propTypes = {
  listTitle: PropTypes.string.isRequired,
  linkText: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  onClick: PropTypes.func,
};

export default GraceListHeader;
